import { render, staticRenderFns } from "./creatSeckillMore.vue?vue&type=template&id=5ccf2f00&scoped=true"
import script from "./creatSeckillMore.vue?vue&type=script&lang=js"
export * from "./creatSeckillMore.vue?vue&type=script&lang=js"
import style0 from "./creatSeckillMore.vue?vue&type=style&index=0&id=5ccf2f00&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccf2f00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ccf2f00')) {
      api.createRecord('5ccf2f00', component.options)
    } else {
      api.reload('5ccf2f00', component.options)
    }
    module.hot.accept("./creatSeckillMore.vue?vue&type=template&id=5ccf2f00&scoped=true", function () {
      api.rerender('5ccf2f00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/seckill/seckillList/creatSeckillMore.vue"
export default component.exports